<template>
  <div>
    <HeroSection theme="blue-gradient">
      <h1 v-if="mortgageWatch != null" class="display-12 text-white font-size-md-down-5 font-weight-semi-bold">
        <span class="text-warning">Remortgage</span> Deals for &quot;<span class="text-warning">{{ mortgageWatch.Description }}</span>&quot;
      </h1>
      <h2 class="display-12 text-white font-size-md-down-5 font-weight-semi-bold">
      </h2>
      <ProductQuerySummary v-if="editMode" :query="searchQuery" @clicked="wizarding = true"/>
    </HeroSection>
    <div class="space-1">
      <b-overlay :show="saving" :opacity="0.3">
        <GettingStartedBanner v-if="!wizarding && false" @cta="wizarding = !wizarding"/>
        <transition name="fade">
          <div v-if="wizarding" class="">
            <div class="container">
              <MortgageWizard :wizard="form" 
                              @completed="wizardCompleted($event)"
                              @close="wizardClosed()"
                              :allow-close="editMode" 
                              close-label="Cancel"/>
            </div>
          </div>
        </transition>
        <div v-if="showProducts" class="">
          <div class="">
            <ProductExplorer 
                v-if="searchQuery != null" 
                :query="searchQuery" 
                :filters="null" 
                hide-filters
                disable-search-modal 
                @retry="openWizard()" />
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
  import HeroSection from "@/components/layout/HeroSection";
  import ProductExplorer from "@/components/ProductExplorer";
  import ProductCardPlaceholder from "@/components/products/ProductCardPlaceholder";
  import {mapGetters, mapActions } from "vuex";
  import MortgageWizard from "@/components/MortgageWizard";
  import GettingStartedBanner from "@/components/mortgage-watch/GettingStartedBanner"
  import {ProductSearchQuery} from "@/utils/ProductSearchQuery";
  import {MortgageWatchQuery} from "@/utils/MortgageWatchQuery.ts";
  import ProductQuerySummary from "@/components/products/ProductQuerySummary";
  import IntroductionToMortgageWatch from "@/components/home/IntroductionToMortgageWatch";
  
  export default {
    name: "MortgageWatch",
    
    data() {
      return {
        wizarding: true,
        editMode: false,
        searchQuery: null,
        form: null,
        mortgageWatch: null,
        saving: false
      }
    },
    
    components: {
      ProductQuerySummary,
      HeroSection,
      MortgageWizard,
      ProductExplorer,
      GettingStartedBanner,
    },
    
    mounted() {
      // const tmp = this.mostRecentWatcher;
      // if (tmp != null) {
      //   this.form = { ...tmp.data };
      // }
      this.loadMortgageWatch(this.$route.params.id);
    },
    
    computed: {
      ...mapGetters([
        "allLenders",
        "watchers", "userWatchers", "mostRecentWatcher", "getWatcher",
        "currentUser", "isLoggedIn"
      ]),
      
      showProducts() {
        return this.searchQuery != null && !this.wizarding;
      }
    },

    methods: {
      ...mapActions([
         "addWatcher", "saveUserWatcher"
      ]),
      
      openWizard() {
        this.wizarding = true;
      },
      
      wizardClosed() {
        this.wizarding = false;
      },
      
      async wizardCompleted(event) {
        this.saving = true;
        this.mortgageWatch = new MortgageWatchQuery(event);
        this.form = { ...this.mortgageWatch };
        await this.saveUserWatcher({owner: this.currentUser.email, data: this.form});
        this.saving = false;
        this.loadMortgageWatch(this.form.uid);
      },
      
      loadMortgageWatch(id) {
        if (id != null) {
          this.form = this.getWatcher(id);
          this.mortgageWatch = this.getWatcher(id);
          this.searchQuery = this.mortgageWatch.ProductSearchQuery;
          this.wizarding = false;
          this.editMode = true;
        }
      }
    }
  }
</script>
